/**
 * @generated SignedSource<<cb21ac4492a2c18b79fc873e9d04f844>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PredictedEndDateModal_viewer$data = {
  readonly project: {
    readonly projectStats: ReadonlyArray<{
      readonly id: string;
      readonly date: string | null;
      readonly totalEstimateMinutes: number | null;
      readonly totalBaselineEstimateMinutes: number | null;
      readonly totalDoneEstimateMinutes: number | null;
      readonly performance: number | null;
      readonly optimisticPerformance: number | null;
      readonly conservativePerformance: number | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PredictedEndDateModal_viewer";
};
export type PredictedEndDateModal_viewer$key = {
  readonly " $data"?: PredictedEndDateModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PredictedEndDateModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PredictedEndDateModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectStats",
          "kind": "LinkedField",
          "name": "projectStats",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalEstimateMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalBaselineEstimateMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalDoneEstimateMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "performance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "optimisticPerformance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "conservativePerformance",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "382350d635e5a90620dd682754b84db3";

export default node;
